import { EntityCard } from '../../../shared/components/patterns';

export default function SupplierCard({ supplier, onDetail, onEdit, onArchive, onDelete }) {
  const active = supplier.status === 'ACTIVE';
  const name = supplier.displayName || supplier.legalName;
  const initial = (name || '?').trim().charAt(0).toUpperCase();

  return (
    <EntityCard
      title={name}
      subtitle={supplier.category || 'Categoria non indicata'}
      initials={initial}
      status={{
        label: active ? 'Attivo' : 'Inattivo',
        tone: active ? 'approved' : 'neutral',
      }}
      meta={[
        {
          label: 'Referente',
          value: supplier.contactName
            ? `${supplier.contactName}${supplier.contactRole ? ` - ${supplier.contactRole}` : ''}`
            : 'Referente non indicato',
        },
        { label: 'Email', value: supplier.contactEmail || supplier.companyEmail || 'Email non indicata' },
        { label: 'Telefono', value: supplier.contactPhone || supplier.companyPhone || 'Telefono non indicato' },
        { label: 'P. IVA', value: supplier.vatNumber || 'Partita IVA non indicata' },
      ]}
      actions={[
        {
          id: 'edit',
          label: 'Modifica fornitore',
          iconKey: 'actions.edit',
          onClick: () => onEdit(supplier),
        },
        {
          id: 'archive',
          label: active ? 'Disattiva fornitore' : 'Riattiva fornitore',
          iconKey: active ? 'actions.power' : 'actions.reset',
          tone: active ? 'danger' : 'default',
          onClick: () => onArchive(supplier),
        },
        onDelete ? {
          id: 'delete-permanently',
          label: 'Elimina definitivamente fornitore',
          iconKey: 'actions.delete',
          tone: 'danger',
          onClick: () => onDelete?.(supplier),
        } : null,
      ].filter(Boolean)}
      onClick={() => onDetail(supplier)}
    />
  );
}
